import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class ChartSharedService {

  private detalleInversionesDataSubject = new BehaviorSubject<any>(null);
  public detalleInversionesData$ = this.detalleInversionesDataSubject.asObservable();

  private fechaEmisionSubject = new BehaviorSubject<string | null>(null);
  public fechaEmision$ = this.fechaEmisionSubject.asObservable();

  private fechaVencimientoSubject = new BehaviorSubject<string | null>(null);
  public fechaVencimiento$ = this.fechaVencimientoSubject.asObservable();

  constructor() {}

  setChartdetalleInversionesData(detalleInversionesData: any) {
    this.detalleInversionesDataSubject.next(detalleInversionesData);
  }

  getChartdetalleInversionesData(): any {
    return this.detalleInversionesDataSubject.getValue();
  }

  setFechaEmision(fechaEmision: string) {
    this.fechaEmisionSubject.next(fechaEmision);
  }
  
  setFechaVencimiento(fechaVencimiento: string) {
    this.fechaVencimientoSubject.next(fechaVencimiento);
  }

  getFechaEmision(): string | null {
    return this.fechaEmisionSubject.getValue();
  }

  getFechaVencimiento(): string | null {
    return this.fechaVencimientoSubject.getValue();
  }
}
